import React from 'react';
import MySizes from './my-sizes/my-sizes';
import PersonalInformation from './personal-information/personal-information';
import AccountDetails from './account-details/account-details';
import DeleteAccount from './delete-account/delete-account';
import AccountPicture from './account-picture/account-picture';
import styles from './account-info.module.scss';

const AccountInfo: React.FC = () => {
  return (
    <div
      className={styles.accountInfo}
      data-cy="account-info-section"
    >
      <AccountPicture />
      <PersonalInformation />
      <div className={styles.divider}></div>
      <AccountDetails />
      <div className={styles.divider}></div>
      <MySizes />
      <div className={styles.divider}></div>
      <DeleteAccount />
    </div>
  );
};

export default AccountInfo;
